export const isWrappedInFreezeFrame = target => target.classList.contains('ff-container');
export const isInsideCKEditor = target => target.matches('.cke_editable *');
export const isInCollapsibleSnippet = target => target.matches('details *');
export const isInLabSidebar = target =>
  target.matches(
    '.lab-sidebar-body *, .lab-sidebar-body---accent *, .lab-sidebar-body-unit *, .lab-exercise__content *',
  );
